import { ReactNode } from "react";

import Login from "../Pages/Login";
import ResetPassword from "../Pages/ResetPassword";

export interface AuthRoute {
  path: string;
  element: ReactNode;
  label?: string;
}

const authRoutes: AuthRoute[] = [
  {
    path: "/login",
    element: <Login />,
    label: "Login",
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    label: "Reset Password",
  },
  {
    path: "/set-password",
    element: <ResetPassword />,
    label: "Set Password",
  },
];

export default authRoutes;
